module.exports = __webpack_public_path__ + "286c197c14854eec41020a01eb96d78d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/stomach/stomach-12.png
// module id = 2452
// module chunks = 0